import { Helmet } from 'react-helmet';
import EducationArticlesListing from 'containers/Education/EducationArticlesListing';

function EducationArticlesTemplate() {
    return (
        <>
            <Helmet>
                <title>Lupa | Educação - Todos</title>
            </Helmet>
            <EducationArticlesListing />
        </>
    );
}

export default EducationArticlesTemplate;
